export default __webpack_public_path__ + "static/media/grata_showcase1.png";